import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class serasaKeys extends MainKeys {
    get place() {
        return Places.serasa
    }
}

export default serasaKeys
